import { ValidatorFn, AbstractControl } from '@angular/forms';
/**
 * @return {?}
 */
export function NoNumericValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const /** @type {?} */ pattern: any = /^[^0-9]+$/i;
    if (control.value && !pattern.test(control.value)) {
      return { noNumeric: { value: control.value } };
    }
    return null;
  };
}
